export default __webpack_public_path__ + "static/media/job_offer6_l.ee671c1a.jpg";